const TimeUnits = Object.freeze({
  MONTH: 'MONTH',
  DAY: 'DAY',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE'
});

export { TimeUnits };
